import { Box, Spinner, Text } from "@adfenix/alexandria";
import { useQuery } from "@tanstack/react-query";
import {
  getHqInvoiceHistory,
  getOfficeInvoiceHistory
} from "api/services/billingService";
import { Table } from "components/Datatable";
import dayjs from "dayjs";
import { BillingService } from "@adfenix/types";

export const InvoiceHistory = ({
  hqId,
  officeId,
  mode
}: {
  hqId?: string;
  officeId?: string;
  mode: "office" | "hq";
}) => {
  const { data, isInitialLoading: isLoading } = useQuery(
    ["getHqInvoiceHistory", hqId],
    () =>
      mode === "hq"
        ? getHqInvoiceHistory(hqId ?? "")
        : getOfficeInvoiceHistory(officeId ?? ""),
    {
      enabled: Boolean(hqId) || Boolean(officeId)
    }
  );

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <Spinner />
      </Box>
    );

  const columns = [
    {
      name: "Invoiced at",
      sortable: true,
      selector: (row: BillingService.CustomerInvoice) => row.invoicedAt,
      cell: (row: BillingService.CustomerInvoice) => (
        <Text data-testid="invoice-date">
          {dayjs(row.invoicedAt).format("MMM DD, YYYY")}
        </Text>
      )
    },

    {
      name: "",

      selector: (row: BillingService.CustomerInvoice) => row.invoiceDownloadUrl,
      cell: (row: BillingService.CustomerInvoice) => (
        <Box>
          <a
            href={row.invoiceDownloadUrl}
            data-loglabel="download-invoice-link"
          >
            Download
          </a>
        </Box>
      )
    }
  ];

  return (
    <>
      <Table
        pagination={data && data?.length > 10}
        keyField="invoicedAt"
        defaultSortField="invoicedAt"
        columns={columns}
        defaultSortAsc={false}
        data={data || []}
      />
    </>
  );
};
